import moment from 'moment'

export const nearestPastHalfHour = (): moment.Moment => {
  const date = moment()
  const remainder = date.minute() % 30
  const roundedTime = moment(date).subtract(remainder, 'minutes')
  return roundedTime
}
